<template>
  <video width="320" height="240" autoplay>
    <source src="https://kapi.iglor.es/v1/medias/download/22/test_video.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>
</template>

<script>
export default {
  name: 'ka-video',
  props: {
    url: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
